import type { VoidFunctionComponent } from 'react';

import { prettyMDY } from '../../../../../shared/utils';
import type { SnippetRejectionDetails } from '../../../../../shared/snippets';

import styles from './RejectedBanner.module.less';

type Props = {
  rejectionDetails: SnippetRejectionDetails;
};

/**
 * The RejectedBanner component displays a message indicating that a snippet
 * has been rejected. It includes when and by whom it was rejected.
 */
const RejectedBanner: VoidFunctionComponent<Props> = ({ rejectionDetails }) => {
  const rejectedBy = rejectionDetails.rejectedBy || 'a deleted user';
  return (
    <div className={styles.rejectedBanner}>
      Snippet rejected by <b>{rejectedBy}</b> on {prettyMDY(rejectionDetails.rejectedAt)}.
    </div>
  );
};

export default RejectedBanner;
